import {default as cx} from "classnames"
import {Question} from "./shared/Question"

export function TextAreaPrompt({
    questionText,
    questionDetail,
    field,
    optional,
    rows,
    data,
    emptyError,
    handle,
    sectionName,
    isRequired = true,
}) {
    return (
        <>
            {sectionName && <div className="text-primary d-flex fs-6 fw-bold">{sectionName}:</div>}
            <Question questionText={questionText} optional={optional} isRequired={isRequired} />
            {questionDetail && <div className="w-100 py-5">{questionDetail}</div>}
            <div className="w-100 py-5">
                <textarea
                    name={field}
                    value={data}
                    onChange={(evt) => handle(evt.target.value)}
                    rows={rows ? rows : 3}
                    className={cx("form-control fs-4", {"border border-1 border-danger": emptyError})}
                />
            </div>
            {emptyError && isRequired && <span className="text-danger mt-n5">Entry is required</span>}
        </>
    )
}
